import { createContext, FC, ReactNode, useContext, useMemo, useState } from 'react';

export enum OperatorStationConfigurationTabEnum {
  CONTEXT = 'CONTEXT',
  SCREENS = 'SCREENS',
}

type ItemType = {
  tab: OperatorStationConfigurationTabEnum;
  id: number | null;
};

interface OperatorStationConfigurationContextType {
  isEditing: boolean;
  editedItem: ItemType | null;
  selectedTab: OperatorStationConfigurationTabEnum;
  setEditedItem: (value: ItemType | null) => void;
  setSelectedTab: (tab: OperatorStationConfigurationTabEnum) => void;
}

const OperatorStationConfigurationContext = createContext<OperatorStationConfigurationContextType | null>(null);

export const OperatorStationConfigurationProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [editedItem, setEditedItem] = useState<ItemType | null>(null);
  const [selectedTab, setSelectedTab] = useState<OperatorStationConfigurationTabEnum>(
    OperatorStationConfigurationTabEnum.CONTEXT,
  );

  const isEditing = editedItem !== null;

  const value = useMemo(
    () => ({
      isEditing,
      editedItem,
      selectedTab,
      setEditedItem,
      setSelectedTab,
    }),
    [editedItem, isEditing, selectedTab],
  );

  return <OperatorStationConfigurationContext value={value}>{children}</OperatorStationConfigurationContext>;
};

export const useOperatorStationConfigurationContext = (): OperatorStationConfigurationContextType => {
  const context = useContext<OperatorStationConfigurationContextType | null>(OperatorStationConfigurationContext);
  if (!context) {
    throw new Error(
      'useOperatorStationConfigurationContext must be used within operator OperatorStationConfigurationProvider',
    );
  }
  return context;
};
